import { useState, useEffect } from 'react';
import { LOADING_MESSAGE_THEMES } from '../constants/loading-messages';

export const useLoadingMessages = (isLoading: boolean) => {
  const [currentLoadingMessageIndex, setCurrentLoadingMessageIndex] = useState(0);

  useEffect(() => {
    if (!isLoading) {
      setCurrentLoadingMessageIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setCurrentLoadingMessageIndex((prev) => {
        if (prev < LOADING_MESSAGE_THEMES.length - 1) {
          return prev + 1;
        }
        return prev;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [isLoading]);

  const currentLoadingTheme = LOADING_MESSAGE_THEMES[currentLoadingMessageIndex] || LOADING_MESSAGE_THEMES[0];

  return {
    currentLoadingMessageIndex,
    currentLoadingTheme,
  };
};

